module.exports = __webpack_public_path__ + "img/noSql.2d6c2f2d.svg";